export const PAGE_SIZE = 21;

export const DEFAULT_FILTERS = {
  isPrivateGig: false,
  JobOrderTypeName: null,
  JobOrderStatusName: "All",
  SkillsId: [],
  Skills: [],
  years_of_experience: [],
  CityId: [],
  cities: [],
  RegionId: [],
  regions: [],
  CountryId: [],
  countries: [],
  vms: [],
  facility: [],
  FacilityId: [],
  facilityNames: [],
};
